import React from 'react'
import { Alert, Heading, LayoutPageWrapper } from 'goustouicomponents'
import { useFetchOpenings } from '../../hooks/useFetchOpenings'
import { OpeningsContent } from './OpeningsContent'
import { smartRecruitersAPI } from '../../config/routes'
import css from './Openings.module.css'

const url = smartRecruitersAPI.jobs

const Openings = () => {
  const { fetchResponse, isFetchLoading } = useFetchOpenings(url)
  const allJobs = fetchResponse?.content || []

  return (
    <section className={css.wrapper}>
      <LayoutPageWrapper padding="large-screens-only">
        <div className={css.textWrapper}>
          <Heading type="h2" size="fontStyleXL" isCenter>
            Openings
          </Heading>
          <p>If all this sounds right up your street, you could be our missing ingredient.</p>
          {!isFetchLoading && !fetchResponse?.content ? (
            <Alert type="danger">
              <Heading type="h3" size="fontStyleM">
                Something went wrong
              </Heading>
              <p>We couldn&apos;t retrieve the jobs for now. Please try again later.</p>
            </Alert>
          ) : (
            <div data-testing="jobOpenings">
              <OpeningsContent allJobs={allJobs} isFetchLoading={isFetchLoading} />
            </div>
          )}
        </div>
      </LayoutPageWrapper>
    </section>
  )
}

export { Openings }
